/**
 * Реестр режимов ассистента (US-10 FR-2).
 *
 * Порядок — как в переключателе панели: Данные · Гид · Записки · Загрузка.
 * `suggestions` — сколько быстрых подсказок лежит в i18n у режима
 * (`assistant.modes.<id>.s1…sN`).
 *
 * Здесь ТОЛЬКО оформление: иконка и число подсказок. Какие режимы показывать
 * этой роли, решает бэк (`GET /api/assistant/modes`) — см. `useAssistantModes`.
 * Раньше тут же стоял фильтр по праву ввода; он дублировал ролевую модель на
 * фронте, и при расхождении с бэком наблюдатель увидел бы «Загрузку» вопреки
 * FR-2.3.
 */
import { BarChart3, Compass, FileText, Upload } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { AssistantMode } from '../../types/assistant';

export interface AssistantModeDef {
  id: AssistantMode;
  icon: LucideIcon;
  suggestions: number;
  /** `false` — режим показывается, но ещё не поставлен (Волна 3). */
  enabled?: boolean;
}

export const ASSISTANT_MODE_LIST: readonly AssistantModeDef[] = [
  { id: 'data', icon: BarChart3, suggestions: 3 },
  { id: 'guide', icon: Compass, suggestions: 3 },
  { id: 'note', icon: FileText, suggestions: 2 },
  { id: 'upload', icon: Upload, suggestions: 2 },
];
